import { useFormContext } from "react-hook-form";

import toast from "components/partials/toast/toast";

import { useCreateCampaignWithWriter } from "components/modals/create-campaign-with-writer-modal/hooks/use-create-campaign-with-writer";
import type { CreateCampaignWithWriterFormData } from "components/modals/create-campaign-with-writer-modal/create-campaign-with-writer-modal.types";

export const useSubmitCampaignWithWriter = (templateValidationError: string | null = null) => {
  const {
    formState: { isValid },
    handleSubmit,
    getValues,
  } = useFormContext<CreateCampaignWithWriterFormData>();
  const { createCampaign, isSubmitting } = useCreateCampaignWithWriter();

  const handleCreateCampaign = handleSubmit(
    () => {
      void createCampaign(getValues());
    },
    () => {
      toast.error({
        data: {
          title: "Failed to create campaign",
          message: "Please complete all required fields before creating the campaign.",
        },
      });
    },
  );

  return {
    handleCreateCampaign,
    isContinueDisabled: !isValid || isSubmitting || Boolean(templateValidationError),
  };
};
